import { ref } from 'vue';

/**
 * @returns {{ showPros: import('vue').Ref<boolean>, loader: Function, isLoading: import('vue').Ref<boolean> }}
 */
export default function useProsLoader({ timeout = 10000, withFallback = false } = {}) {
  const showPros = ref(true);
  const isLoading = ref(true);
  let timer;

  if (withFallback) {
    onMounted(() => {
      timer = setTimeout(() => {
        isLoading.value = false;
      }, timeout);
    });

    onUnmounted(() => {
      clearTimeout(timer);
    });
  }

  const loader = (loaded) => {
    if (withFallback) clearTimeout(timer);
    isLoading.value = false;
    showPros.value = loaded;
  };

  return {
    showPros,
    loader,
    isLoading,
  };
}
